import { FilterType, ReportShapeItem } from '../../reportsTypes';
import * as z from 'zod';
import { ZodObject } from 'zod';

export const shipSchema = z.object({
  name: z.string(),
  mmsi: z.string(),
  callSign: z.string(),
  imo: z.string(),
  type: z.string(),
});

export type Ship = z.infer<typeof shipSchema>;

export function createDynamicFilterZodSchema(
  filterType: FilterType
): ZodObject<Record<string, z.ZodTypeAny>> {
  const schemaFields: Record<string, z.ZodTypeAny> = {};
  if (filterType === 'normal') {
    schemaFields['filter'] = z.string().optional();
  } else if (filterType === 'ship') {
    schemaFields['filter'] = z.array(shipSchema).nonempty();
  } else if (filterType === 'shiplist') {
    schemaFields['filter'] = z.string().min(1);
  } else if (filterType === 'combined') {
    schemaFields['shiplist'] = z.string();
    schemaFields['filter'] = z.string();
  }

  return z.object(schemaFields);
}
